import { render, staticRenderFns } from "./TheLayout.vue?vue&type=template&id=3436f30c&scoped=true&"
import script from "./TheLayout.vue?vue&type=script&lang=js&"
export * from "./TheLayout.vue?vue&type=script&lang=js&"
import style0 from "./TheLayout.vue?vue&type=style&index=0&lang=less&"
import style1 from "./TheLayout.vue?vue&type=style&index=1&id=3436f30c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3436f30c",
  null
  
)

export default component.exports